import "./TheObserver.module.css";
import Header from "@/reusable_sections/Header";
import Coord01TheObserver from "./sections/Coord01TheObserver";
import Coord02TheEquipment from "./sections/Coord02TheEquipment";
import Coord03TheMission from "./sections/Coord03TheMission";
import Coord04ExternalArchive from "./sections/Coord04ExternalArchive";
import Footer from "@/reusable_sections/Footer";
export default function TheObserverPage() {
  return <div>
      <Header />
      <Coord01TheObserver />
      <Coord02TheEquipment />
      <Coord03TheMission />
      <Coord04ExternalArchive />
      <Footer />
    </div>;
}